






























































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { FormState } from '@/components/prine/enums/FormState';
import DetailedConfirmModal from '@/components/prine/DetailedConfirmModal.vue';

import type { User } from '@/models/user';
import PrineButton from '@/components/prine/PrineButton.vue';
import type { XSubProcess } from '@/models/xsubprocess';
import type { XProcess } from '@/models/xprocess';
import { xSubProcessWebservice } from '@/webservices/xsubprocess';
import type { CompanySetting } from '@/models/companySetting';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'StoreUpdateXSubProcess',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {
        DetailedConfirmModal,
        PrineButton,
    },
})
export default class StoreUpdateXSubProcess extends Vue {
    public FormState = FormState;

    // Data
    protected disabled: boolean = false;
    protected loaded: boolean = false;
    protected errorMsg: string = '';
    protected isConfirmModalActive: boolean = false;
    protected state: FormState = FormState.New;

    protected xsubprocess: XSubProcess = {
        x_process: {} as XProcess,
    } as XSubProcess;

    protected loading = {
        data: false,
        color: '#fdc05d',
        size: '40px',
    };

    protected affectedData: Map<string, number> = new Map();

    @Getter('account/userInfo') private userInfo: User;
    @Getter('account/companySetting') private companySetting: CompanySetting;
    @Getter('utils/currentLocale') private currentLocale: string;

    // Mounted is called initially
    private mounted() {
        if (this.$route.query.subPhaseId) {
            this.load(this.$route.query.subPhaseId.toString());
            this.state = FormState.Update;
        }

        // If there is a phaseId passed store it in the model
        if (this.$route.query.phaseId) {
            this.xsubprocess.x_process.id = Number(this.$route.query.phaseId);
        }
        this.loaded = true;
    }

    private load(phaseId: string) {
        this.loading.data = true;
        xSubProcessWebservice.getById(phaseId).then((response) => {
            this.xsubprocess = response.data;
            this.loading.data = false;

            this.affectedData.set(this.$tc('keywords.lesson', 2).toString(), this.xsubprocess.x_lessons_count);
        });
    }

    private save() {
        this.disabled = true;
        if (!this.validate()) {
            this.disabled = false;
            return 0;
        }

        if (this.state === FormState.New) {
            xSubProcessWebservice
                .store(this.xsubprocess)
                .then((response) => {
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: this.$t('toastMessages.store.generic', {
                            x:
                                this.currentLocale === 'en'
                                    ? this.companySetting.x_en_sub_process_title
                                    : this.companySetting.x_de_sub_process_title,
                        }).toString(),
                        type: 'is-success',
                    });
                    this.$router.push({
                        name: 'GroupedXLessonsList',
                        query: {
                            phaseId: this.xsubprocess.x_process.id.toString(),
                        },
                    });
                    this.$emit('syncKnowledge');
                })
                .catch((error) => {
                    this.disabled = false;
                    console.log(error);
                });
        } else if (this.state === FormState.Update) {
            xSubProcessWebservice
                .update(this.xsubprocess)
                .then((response) => {
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: this.$t('toastMessages.update.generic', {
                            x:
                                this.currentLocale === 'en'
                                    ? this.companySetting.x_en_sub_process_title
                                    : this.companySetting.x_de_sub_process_title,
                        }).toString(),
                        type: 'is-success',
                    });
                    this.$router.push({
                        name: 'GroupedXLessonsList',
                        query: {
                            phaseId: this.xsubprocess.x_process.id.toString(),
                        },
                    });
                    this.$emit('syncKnowledge');
                    this.disabled = false;
                })
                .catch((error) => {
                    this.disabled = false;
                    console.log(error);
                });
        }
    }

    private toggleConfirmModal(answer) {
        this.isConfirmModalActive = !this.isConfirmModalActive;
        if (answer === true) {
            this.remove();
        }
    }

    private remove() {
        xSubProcessWebservice
            .remove(this.xsubprocess)
            .then((response) => {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: this.$t('toastMessages.delete.generic', {
                        x:
                            this.currentLocale === 'en'
                                ? this.companySetting.x_en_sub_process_title
                                : this.companySetting.x_de_sub_process_title,
                    }).toString(),
                    type: 'is-success',
                });
                this.$router.push({
                    name: 'GroupedXLessonsList',
                    query: {
                        phaseId: this.xsubprocess.x_process.id.toString(),
                    },
                });
                this.$emit('syncKnowledge');
            })
            .catch((error) => {
                console.log(error);
            });
    }

    private validate() {
        if (!this.xsubprocess.title || this.xsubprocess.title === '') {
            this.errorMsg = 'title';
            return 0;
        } else if (this.xsubprocess.order === undefined || isNaN(Number(this.xsubprocess.order))) {
            this.errorMsg = 'orderNotNumber';
            return 0;
        } else {
            return true;
        }
    }
}
